export default "__VITE_ASSET__Crj_r2Qs__"